export default [
    {
        path: "/api-key",
        name: "LLMApiKey",
        component: () => import("@/views/llm-api-key/api-key-list"),
        meta: {title: "API-Key管理", activeMenu: "/api-key"},
    },
]
